import {Stack} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";
import DigitalSigningPageTextField from "./DigitalSigningPageTextField";
import {SETTINGS_ROWS_GAP} from "./DigitalSigningSettingsSection";
import {DigitalSigningTemplateForm, PageTexts} from "./digitalSigningTemplate.util";

type TitleTexts = Pick<DigitalSigningTemplateForm, 'titles' | 'subtitles'>;

interface Props {
    value: TitleTexts
    onChange: (value: TitleTexts) => void
    errors?: {titles?: Partial<PageTexts>, subtitles?: Partial<PageTexts>}
    disabled?: boolean
}

/** Page title and subtitle input fields for each supported language. */
const DigitalSigningTitleFields = ({value, onChange, errors, disabled}: Props) => {
    const {t} = useTranslation();

    return (
        <Stack gap={SETTINGS_ROWS_GAP}>
            <DigitalSigningPageTextField
                id={'digital-signing-title'}
                title={t('Title')}
                tooltip={t('Large at the top of the page. Empty: the page\'s own title, “Spa confirmation”, “Restaurant confirmation” or “Confirmation”.')}
                value={value.titles}
                onChange={titles => onChange({...value, titles})}
                errors={errors?.titles}
                disabled={disabled}
            />
            <DigitalSigningPageTextField
                id={'digital-signing-subtitle'}
                title={t('Subtitle')}
                tooltip={t('A smaller line under the title. Empty: not shown.')}
                value={value.subtitles}
                onChange={subtitles => onChange({...value, subtitles})}
                errors={errors?.subtitles}
                disabled={disabled}
            />
        </Stack>
    );
};

export default DigitalSigningTitleFields;
